import React, { useState } from "react";
import { Badge } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../Components/Items";
import ListaTicketsSoporte from "../Chat/ListaTicketsSoporte";
import ConversacionMovil from "../Chat/ConversacionMovil";
import ChipsFase from "../Chat/ChipsFase";
import InfoReporte from "../Chat/InfoReporte";
import TagFase from "../Chat/TagFase";
import TagRespuestaCliente from "../Chat/TagRespuestaCliente";
import AccionesSubido from "../Chat/AccionesSubido";
import AvisoHorario from "../Chat/AvisoHorario";
import { SOPORTE_TEMA, FASES_LABEL } from "../Chat/fasesSoporte";

const fechaActividad = (t) => new Date(t.ultimoMensajeFecha || t.createdAt).getTime();

const TicketsMovil = ({
    tickets,
    loading,
    ordenFases,
    columnaDeFase,
    usuarioId,
    esMaster,
    noLeidos,
    onSeleccionar,
    onNuevoTicket,
    ticketActivo,
    mensajes,
    loadingMensajes,
    enviando,
    onVolver,
    onEnviarMensaje,
    soloLectura,
    textoSoloLectura,
    modoPeticiones,
    selectorPestana,
    accionesPeticion,
    puedeResponderSubido,
    respondiendo,
    onResponderSubido,
}) => {
    const [faseFiltro, setFaseFiltro] = useState("todos");

    if (ticketActivo) {
        return (
            <ConversacionMovil
                titulo={ticketActivo.titulo}
                meta={
                    <>
                        <TagFase fase={ticketActivo.fase} />
                        <TagRespuestaCliente respuesta={ticketActivo.respuestaCliente} />
                        <span style={{ fontSize: 11, color: SOPORTE_TEMA.textSecondary, whiteSpace: "nowrap" }}>
                            {ticketActivo.folio}
                        </span>
                    </>
                }
                onVolver={onVolver}
                mensajes={mensajes}
                loadingMensajes={loadingMensajes}
                enviando={enviando}
                onEnviar={onEnviarMensaje}
                perspectivaAgente={false}
                usuarioId={usuarioId}
                soloLectura={soloLectura}
                textoSoloLectura={textoSoloLectura}
                etiquetaAccion={accionesPeticion ? "Revisar" : "Reporte"}
                resaltarAccion={!!accionesPeticion}
                panelTitulo="Detalle del reporte"
                // Sin notasInternas: los comentarios técnicos de Jira nunca se le muestran al cliente.
                panelContenido={() => (
                    <>
                        {accionesPeticion && <div style={{ marginBottom: 14 }}>{accionesPeticion}</div>}
                        {puedeResponderSubido && (
                            <div style={{ marginBottom: 14 }}>
                                <AccionesSubido
                                    ticket={ticketActivo}
                                    guardando={respondiendo}
                                    onResponder={onResponderSubido}
                                    compacto
                                />
                            </div>
                        )}
                        <InfoReporte ticket={ticketActivo} />
                    </>
                )}
            />
        );
    }

    // misTickets trae todos los reportes de una vez, así que el filtro y el orden
    const opcionesFase = [
        { label: "Todos", value: "todos" },
        ...ordenFases.map((fase) => ({ label: FASES_LABEL[fase], value: fase })),
    ];
    const visibles = tickets
        .filter((t) => modoPeticiones || faseFiltro === "todos" || columnaDeFase(t.fase) === faseFiltro)
        .sort((a, b) => fechaActividad(b) - fechaActividad(a));

    return (
        <>
            <div style={{ backgroundColor: SOPORTE_TEMA.surface, borderRadius: 7, overflow: "hidden" }}>
                <div style={{ padding: "10px 12px", borderBottom: `1px solid ${SOPORTE_TEMA.border}` }}>
                    <div
                        style={{
                            fontSize: 15,
                            fontWeight: 600,
                            color: SOPORTE_TEMA.textPrimary,
                            marginBottom: 8,
                        }}
                    >
                        Tickets de Soporte
                        {noLeidos > 0 && (
                            <Badge
                                count={noLeidos}
                                overflowCount={99}
                                style={{ backgroundColor: SOPORTE_TEMA.primario, marginLeft: 8 }}
                            />
                        )}
                    </div>
                    {selectorPestana && <div style={{ marginBottom: 8, overflowX: "auto" }}>{selectorPestana}</div>}
                    <AvisoHorario style={{ marginBottom: 8 }} />
                    {!modoPeticiones && (
                        <ChipsFase opciones={opcionesFase} valor={faseFiltro} onChange={setFaseFiltro} />
                    )}
                </div>
                <ListaTicketsSoporte
                    tickets={visibles}
                    loading={loading}
                    onSelect={onSeleccionar}
                    onNuevoTicket={onNuevoTicket}
                    mostrarReportero={esMaster || modoPeticiones}
                    usuarioId={usuarioId}
                    modoPeticiones={modoPeticiones}
                    header={null}
                    anchoTexto="100%"
                />
            </div>

            {/* Reportar es la acción principal del cliente: va al alcance del pulgar.
                El position va en el contenedor porque ButtonItem aplica el style al botón. */}
            <div style={{ position: "fixed", right: 20, bottom: 24, zIndex: 900 }}>
                <ButtonItem
                    naranja
                    icon={<PlusOutlined />}
                    onClick={onNuevoTicket}
                    style={{ height: 48, borderRadius: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.25)" }}
                >
                    Reportar
                </ButtonItem>
            </div>
        </>
    );
};

export default TicketsMovil;
